import { render, staticRenderFns } from "./EventApplyMobile.vue?vue&type=template&id=0048a21c&scoped=true"
import script from "./EventApplyMobile.vue?vue&type=script&lang=js"
export * from "./EventApplyMobile.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0048a21c",
  null
  
)

export default component.exports